import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import HowItWorksPage from "../pages/HowItWorksPage";
import BlogPage from "../pages/BlogPage";
import ContactPage from "../pages/ContactPage";
import TermsPage from "../pages/TermsPage";
import PrivacyPage from "../pages/PrivacyPage";
import RefundPage from "../pages/RefundPage";
import CookiesPage from "../pages/CookiesPage";
import AustriaPage from "../pages/AustriaPage";
import HungaryPage from "../pages/HungaryPage";
import SwitzerlandPage from "../pages/SwitzerlandPage";
import CzechiaPage from "../pages/CzechiaPage";
import SlovakiaPage from "../pages/SlovakiaPage";
import SloveniaPage from "../pages/SloveniaPage";
import RomaniaPage from "../pages/RomaniaPage";
import BulgariaPage from "../pages/BulgariaPage";
import BlogFinesPage from "../pages/BlogFinesPage";
import BlogTrailerPage from "../pages/BlogTrailerPage";
import BlogEvsStickerPage from "../pages/BlogEvsStickerPage";
import BlogMultiCountryPage from "../pages/BlogMultiCountryPage";
import BlogMotorcyclePage from "../pages/BlogMotorcyclePage";
import BlogCamerasPage from "../pages/BlogCamerasPage";
import BlogPricesPage from "../pages/BlogPricesPage";
import BlogScamsPage from "../pages/BlogScamsPage";
import BlogStartDatePage from "../pages/BlogStartDatePage";
import CheckoutPage from "../pages/CheckoutPage";
import SuccessPage from "../pages/SuccessPage";
import EmailPurchasePage from "../pages/EmailPurchasePage";
import EmailVignettePage from "../pages/EmailVignettePage";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/how-it-works", element: <HowItWorksPage /> },
  { path: "/blog", element: <BlogPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "/terms", element: <TermsPage /> },
  { path: "/privacy", element: <PrivacyPage /> },
  { path: "/refund", element: <RefundPage /> },
  { path: "/cookies", element: <CookiesPage /> },
  { path: "/austria", element: <AustriaPage /> },
  { path: "/hungary", element: <HungaryPage /> },
  { path: "/switzerland", element: <SwitzerlandPage /> },
  { path: "/czechia", element: <CzechiaPage /> },
  { path: "/slovakia", element: <SlovakiaPage /> },
  { path: "/slovenia", element: <SloveniaPage /> },
  { path: "/romania", element: <RomaniaPage /> },
  { path: "/bulgaria", element: <BulgariaPage /> },
  { path: "/blog/fines-for-no-vignette", element: <BlogFinesPage /> },
  { path: "/blog/paying-tolls-with-trailer", element: <BlogTrailerPage /> },
  { path: "/blog/what-is-an-e-vignette", element: <BlogEvsStickerPage /> },
  { path: "/blog/multi-country-vignette-guide", element: <BlogMultiCountryPage /> },
  { path: "/blog/motorcycle-vignette-rules", element: <BlogMotorcyclePage /> },
  { path: "/blog/vignette-enforcement-cameras", element: <BlogCamerasPage /> },
  { path: "/blog/vignette-prices-2026", element: <BlogPricesPage /> },
  { path: "/blog/avoid-vignette-scams", element: <BlogScamsPage /> },
  { path: "/blog/vignette-start-date-strategy", element: <BlogStartDatePage /> },
  { path: "/checkout", element: <CheckoutPage /> },
  { path: "/success", element: <SuccessPage /> },
  { path: "/email/purchase", element: <EmailPurchasePage /> },
  { path: "/email/vignette", element: <EmailVignettePage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;